import service from "@/utils/request";
import { getToken } from "@/utils/auth";
import { ElMessage } from "element-plus";

export const pushNotification = async (notification) => {
    try {
        const response = await service.post('/notifications', notification , {
            headers: {
                'Authorization': `Bearer ${getToken()}`,
                'Content-Type': 'multipart/form-data',  // Important for file uploads
            }
        });
        ElMessage({
            type: 'success',
            message:'Notification Send Successfully',
        })
        return response.data;
    } catch (e) {
        ElMessage({
            type: 'error',
            message:e.response.data.message,
        })
        throw e;
    }
};

export const getNotification = async (page) => {
    try {
        const response = await service.get('/notifications?page='+page);
        return response;
    } catch (e) {
        ElMessage({
            type: 'error',
            message:e.response.data.message,
        })
        throw e;
    }
};


export const markAsSeen = async () => {
    try {
        const response = await service.post('/notifications/mark-all-seen');
        return response;
    } catch (e) {
        ElMessage({
            type: 'error',
            message:e.response.data.message,
        })
        throw e;
    }
};
